import React from 'react';
import qs from 'qs';
import axios from 'axios';

import './contact_form.scss';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputs: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      formSending: false,
      formSent: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    const ScrollMagic = require('ScrollMagic');
    require('animation.gsap');
    require('TweenMax');

    this.controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: '#contact-form',
      triggerHook: 1
    })
      .setTween(TweenMax.staggerFromTo('#contact-form > div > *', 0.1, {opacity: 0, marginLeft: '-25%'}, {opacity: 1, marginLeft: 0}, 0.1))
      .reverse(false)
      .addTo(this.controller);

    // Add netlify honeypot because react won't let me do it as a prop
    this.form.setAttribute('netlify-honeypot', 'bot-field');
  }

  componentWillUnmount() {
    this.controller.destroy();
  }

  handleChange(e) {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value; 
    var inputs = this.state.inputs;
    inputs[e.target.name] = value;
    this.setState({ inputs: inputs });
  }

  handleFormSubmit(e) {
    e.preventDefault();

    TweenMax.to('#contact-form input', 0.1, {color: '#000000', borderColor: '#a2a2a2'});

    const constraints = {
      name: { 
        presence: {
          allowEmpty: false
        }
      },
      email: {
        email: true
      },
      message: {
        presence: {
          allowEmpty: false
        }
      }
    };

    const url = e.target.getAttribute('action');
    const data = qs.stringify({'form-name': 'contact', ...this.state.inputs});
    this.setState({ formSending: true });
    axios.post(url, data).then(() => {
      this.setState({ formSending: false, formSent: true });  
    });
  }

  render() {
    const { formSending, formSent } = this.state;
    return (
      <div id="contact" className="contact target container page-padding">
        <div className="form-container">
          {formSent === false ? (
            <h2 className="title">Contact Us</h2>
          ) : (
            <h2 className="title">Thank you!</h2>
          )}
          <form
            id="contact-form"
            action="."
            name="contact"
            ref={el => this.form = el}
            data-netlify="true"
            onSubmit={this.handleFormSubmit}
            className={formSent ? 'form-sent' : ''}
          >
            <div className="form-controls">
              <div style={{visibility: 'hidden',position:'absolute',left:'-30000px'}}>
                <label>Bot field: <input name="bot-field" /></label>
                <input name="form-name" type="hidden" defaultValue="Hire" disabled="true" />
              </div>
              <input type="text" name="name" placeholder="Name" value={this.state.name} onChange={this.handleChange} required /><br />
              <input type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.handleChange} /><br />
              <input type="tel" name="phone" placeholder="Phone Number" value={this.state.phone} onChange={this.handleChange} /><br />
              <textarea className="tk-aktiv-grotesk" name="message" placeholder="Message" value={this.state.message} onChange={this.handleChange} required /><br />
              {formSending === false ? (
                <button type="submit" className="btn">Submit +</button>
              ) : (
                <span>Sending Message...</span>
              )}
            </div>
            
            <div className="success">
              Your message has been sent.
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default ContactForm;




// WEBPACK FOOTER //
// ./src/components/contact_form/contact_form.js